import { render, staticRenderFns } from "./screen2_new.vue?vue&type=template&id=c9b5a348&scoped=true&"
import script from "./screen2_new.vue?vue&type=script&lang=js&"
export * from "./screen2_new.vue?vue&type=script&lang=js&"
import style0 from "./screen2_new.vue?vue&type=style&index=0&id=c9b5a348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b5a348",
  null
  
)

export default component.exports